import { AI_MODELS, getRandomSetOfStarterPrompts } from '../components/bot/constants';

// chatSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { getInfo } from '../services/user'

const initialState = {
    userInfo: {
        messagesRemaining: 0,
        email: '',
        firstName: '',
        lastName: '',
    },
    preferences: {
        useTools: true,
        useSuggestions: true,
        useAdminTools: false,
    },
    processing: false,
    model: AI_MODELS[0].value,
    userInput: '',
    suggestions: getRandomSetOfStarterPrompts(),
    messages: [
        {
            id: 0,
            content: `Zap! I'm AI fast like lightning⚡here to electrify your day. What's sparking your curiosity?`,
            role: 'assistant',
        }
    ],
};

const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setMessagesRemaining: (state, action) => {
            state.userInfo.messagesRemaining = action.payload;
        },
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        setUseSuggestions: (state, action) => {
            state.preferences.useSuggestions = action.payload;
        },
        setUseTools: (state, action) => {
            state.preferences.useTools = action.payload;
        },
        setUseAdminTools: (state, action) => {
            state.preferences.useAdminTools = action.payload;
        },
        setProcessing: (state, action) => {
            state.processing = action.payload;
        },
        setSuggestions: (state, action) => {
            state.suggestions = action.payload;
        },
        setModel: (state, action) => {
            state.model = action.payload;
        },
        setUserInput: (state, action) => {
            state.userInput = action.payload;
        },
        upsertMessage: (state, action) => {
            const { id, content, ...rest } = action.payload;

            const existingMessage = state.messages.find(msg => msg.id === id);
            if (existingMessage) {
                existingMessage.content += content;
            } else {
                state.messages.push({ id, content, ...rest });
            }
        },
        clearMessages: (state) => {
            state.messages = initialState.messages;
        },
    }
});

// Selectors
export const selectUserInfoMessagesRemaining = (state) => state.chat.userInfo.messagesRemaining;
export const selectUserInfo = (state) => state.chat.userInfo;
export const selectUseAdminTools = (state) => state.chat.preferences.useAdminTools;
export const selectUseSuggestions = (state) => state.chat.preferences.useSuggestions;
export const selectUseTools = (state) => state.chat.preferences.useTools;
export const selectProcessing = (state) => state.chat.processing;
export const selectSuggestions = (state) => state.chat.suggestions;
export const selectModel = (state) => state.chat.model;
export const selectMessages = (state) => state.chat.messages;
export const selectUserInput = (state) => state.chat.userInput;
export const selectMessageById = (state, id) => state.chat.messages.find(msg => msg.id === id);

// Async actions
export const loadUserInfoAsync = () => async (dispatch) => {
    try {
        const response = await getInfo();
        dispatch(setUserInfo({
            "messagesRemaining": response.gray_messages_remaining,
            "email": response.email,
            "firstName": response.firstName,
            "lastName": response.lastName,
        }));
    } catch (error) {
        console.error('Error fetching user info:', error);
    }
}

// Export actions and reducer
export const {
    upsertMessage,
    clearMessages,
    setUserInput,
    setModel,
    setSuggestions,
    setProcessing,
    setUseTools,
    setUseSuggestions,
    setUseAdminTools,
    setUserInfo,
    setMessagesRemaining,
} = chatSlice.actions;
export default chatSlice.reducer;
